/* src/app/module/service-provider/service-provider.component.scss */
body {
  margin-left: 250px;
  background-color: #FCFCFD;
  padding: 32px;
  overflow-y: auto;
}
.empty-state {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
  color: #bbb;
}
::ng-deep .p-tabview .p-tabview-nav {
  background: transparent;
  border: none;
  border-bottom: 1px solid #E4E7EC !important;
}
::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
  background: transparent !important;
  color: #6B7280;
  padding: 0px 4px 16px 4px;
  font-weight: 600;
  margin-right: 20px;
  position: relative;
  font-size: 14px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #D47500 !important;
  border: none !important;
  margin-bottom: 0px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2.8px;
  background: #D47500;
}
::ng-deep .p-tabview .p-tabview-panels {
  background: transparent;
  padding: 24px 0 0 0;
  border: none;
}
::ng-deep .p-tabview .p-tabview-nav-content {
  border: none !important;
}
::ng-deep .p-inputtext {
  border-radius: 8px;
}
::ng-deep .p-dropdown {
  margin-top: 8px;
  margin-bottom: 4px;
}
::ng-deep .p-inputtext {
  margin-top: 8px;
  margin-bottom: 4px;
}
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
}
::ng-deep .p-inputtext:hover {
  outline: none !important;
  border-color: orange !important;
}
::ng-deep .p-dropdown:focus {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  background-color: white !important;
}
::ng-deep .p-dropdown:hover-visible {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .p-dropdown:hover {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  background-color: white !important;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep textarea:hover,
textarea:focus {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
::ng-deep .p-dropdown.p-focus,
::ng-deep .p-dropdown.p-highlight,
::ng-deep .p-dropdown:focus-within {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep textarea.p-focus,
::ng-deep textarea.p-highlight,
::ng-deep textarea:focus-within {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .col-2 {
  padding: 0px;
}
/*# sourceMappingURL=service-provider.component-53DR2OT4.css.map */
